import { render, staticRenderFns } from "./AgendaEditFormColorPicker.vue?vue&type=template&id=7fe5017a&scoped=true&"
import script from "./AgendaEditFormColorPicker.vue?vue&type=script&lang=js&"
export * from "./AgendaEditFormColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./AgendaEditFormColorPicker.vue?vue&type=style&index=0&id=7fe5017a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe5017a",
  null
  
)

export default component.exports